'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$111() {
  this.bdx = null;
  this.bdy = false;
}
export { $c_Lpresto_PrestoRouter$$anon$111 as $c_Lpresto_PrestoRouter$$anon$111 };
$p = $c_Lpresto_PrestoRouter$$anon$111.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$111;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$111() {
}
export { $h_Lpresto_PrestoRouter$$anon$111 as $h_Lpresto_PrestoRouter$$anon$111 };
$h_Lpresto_PrestoRouter$$anon$111.prototype = $p;
$p.P = (function() {
  if ((!this.bdy)) {
    this.bdx = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T1($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.bdy = true;
  }
  return this.bdx;
});
var $d_Lpresto_PrestoRouter$$anon$111 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$111, "presto.PrestoRouter$$anon$111", ({
  NJ: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$111 as $d_Lpresto_PrestoRouter$$anon$111 };
//# sourceMappingURL=presto.-Presto-Router$$anon$111.js.map
